import { apiRequestSecureGet, apiRequestSecuredPost } from "../lib/common/api";

import {
    TChatList,
    TChatListResponse,
    TChatResponse,
} from "../lib/types/chats";

const endpointAPIChats = "chats/conversations";
const endpointAPIStartConversation = "chats/conversation/start/";
const endpointAPIEndConversation = "chats/conversation/end/";
const endpointAPIGetMessages = "chats/conversation/messages/";
const endpointAPIGetChatList = "chats/chatlist/";
const endpoingAPIPostSendToArchive = "chats/archive";

export const getConversations = async (
    userTokenId: string
): Promise<TChatResponse> => {
    const resp = await apiRequestSecureGet<TChatResponse>(
        endpointAPIChats,
        userTokenId
    );

    return resp.data;
};
export const getMessages = async (
    userTokenId: string,
    conversationId: number,
    lastMessageDateNoTZ?: string
): Promise<TChatResponse> => {
    const dateFilter =
        lastMessageDateNoTZ === undefined
            ? ""
            : `/${encodeURIComponent(lastMessageDateNoTZ)}`;
    const resp = await apiRequestSecureGet<TChatResponse>(
        endpointAPIGetMessages +
            encodeURIComponent(conversationId) +
            dateFilter,
        userTokenId
    );

    return resp.data;
};

export const startChatting = async (
    userTokenId: string,
    withUserId: number
): Promise<TChatResponse> => {
    const resp = await apiRequestSecureGet<TChatResponse>(
        endpointAPIStartConversation + encodeURIComponent(withUserId),
        userTokenId
    );
    return resp.data;
};

export const endChatting = async (
    userTokenId: string,
    withUserId: number
): Promise<TChatResponse> => {
    const resp = await apiRequestSecureGet<TChatResponse>(
        endpointAPIEndConversation + encodeURIComponent(withUserId),
        userTokenId
    );
    return resp.data;
};

export const sendMessage = async (
    content: string,
    userTokenId: string,
    conversationId: number
) => {
    return await apiRequestSecuredPost(
        endpointAPIGetMessages + encodeURIComponent(conversationId),
        userTokenId,
        {
            content,
        }
    );
};
export const chatList = async (
    userTokenId: string,
    pageNumber: number,
    is_archived: boolean
): Promise<{ chatList: TChatList; totalCount: number }> => {
    let archive_param = "";
    if (is_archived) {
        archive_param = "?is_archived=true";
    }
    const endpoint = `${endpointAPIGetChatList}${pageNumber}${archive_param}`;
    const resp = await apiRequestSecureGet<TChatListResponse>(
        endpoint,
        userTokenId
    );
    return { chatList: resp.data.data, totalCount: resp.data.data.totalCount };
};

export const sendToArchive = async (
    conversation_id: number,
    userTokenId: string,
    setArchive: boolean
) => {
    return await apiRequestSecuredPost(
        endpoingAPIPostSendToArchive,
        userTokenId,
        {
            conversation_id,
            setArchive,
        }
    );
};
